/* eslint-disable no-useless-concat */
/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import TableRow from "../../Helpers/Table/TableRow";
import { formatDate, formatDateString } from "../../../JsHelpers/DateFormat";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { exportContext } from "../../../context/ExportDataContext";
import Empty from "../../Helpers/Empty/Empty";
import { useGetSpecificDeviceQuery } from "../../../Redux/service/Devices";
import trans, { isRTL } from "../../../utils";

export default function ReportSheetTableBody({
	data,
	Loading,
	isShown,
	exportData,
	name,
}) {
	const [geoCodes, setGeoCode] = useState({});
	const { pathname } = useLocation();
	let { setExportedDataBody, setFileName } = useContext(exportContext);
	const { data: Name } = useGetSpecificDeviceQuery(
		data?.[0]?.deviceId,
		{ skip: !data?.[0]?.deviceId } // Skip query if deviceId is not available
	);
	const fetchGeoCodePosition = async (lat, lon, id) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);
			setGeoCode((prev) => ({
				...prev,
				[id]: response.data.display_name,
			}));
		} catch (error) {
			console.error("Error fetching geocode position:", error);
		}
	};
	const fetchMultipleGeoCodePosition = async (lat, lon, id, type) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`
			);

			setGeoCode((prev) => ({
				...prev,
				[id]: {
					...prev[id],
					[type]: response.data.display_name,
				},
			}));
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};

	const truncateItem = (text) => {
		const maxLength = 15;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	function convertMillisecondsToTime(ms) {
		const totalMinutes = Math.floor(ms / 60000); // Convert ms to minutes
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		if (isRTL) {
			return `${hours}س ${minutes}د`;
		} else {
			return `${hours}h ${minutes}m`;
		}
	}

	const getShortPath = () => {
		return pathname.split("/").pop(); // "vehicletracking"
	};
	function knotsToKmPerHour(knots) {
		return knots * 1.852;
	}
	useEffect(() => {
		let formattedData = [];
		switch (getShortPath()) {
      case "vehiclestrips":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          formatDateString(i.startTime),
          i.startAddress,
          (i.startOdometer / 1000).toFixed(1) + " " + trans("km"),
          formatDateString(i.endTime),
          i.endAddress,
          (i.endOdometer / 1000).toFixed(1) + " " + trans("km"),
          knotsToKmPerHour(i.averageSpeed).toFixed(1) + " " + trans("km/h"),
          (i.distance / 1000).toFixed(1) + " " + trans("km"),
          convertMillisecondsToTime(i.duration),
        ]);
        break;

      case "speed":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          formatDateString(i.startTime),
          formatDateString(i.endTime),
          knotsToKmPerHour(i.maxSpeed).toFixed(1) + " " + trans("km/h"),
          knotsToKmPerHour(i.averageSpeed).toFixed(1) + " " + trans("km/h"),
          convertMillisecondsToTime(i.engineHours),
        ]);
        break;

      case "alarm":
        setExportedDataBody([]);
        formattedData = data?.map((i) => [i.eventTime, i.type, i.Data]);
        break;

      case "stop":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          formatDateString(i.startTime),
          formatDateString(i.endTime),
          convertMillisecondsToTime(i.duration),
          (i.endOdometer / 1000).toFixed(1) + " " + trans("km"),
        ]);
        break;

      case "distance":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          formatDateString(i.endTime),
          (i.distance / 1000).toFixed(1) + " " + trans("km"),
          (i.startOdometer / 1000).toFixed(1) + " " + trans("km"),
          (i.endOdometer / 1000).toFixed(1) + " " + trans("km"),
        ]);
        break;

      case "devicebehavior":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          // name,
          formatDate(i?.fixTime).formattedDate +
            " " +
            formatDate(i?.fixTime).formattedTime,
          i.address,
          i.speed.toFixed(2) + " " + trans("km/h"),
          i.attributes.totalDistance.toFixed(1) + " " + trans("km"),
          i.attributes.distance.toFixed(1) + " " + trans("km"),
          i.attributes.ignition ? "ON" : "OFF",
          i.attributes.odometer / 1000 + " " + trans("km"),
          i.attributes.event,
          i.attributes.power,
          i.attributes.battery,
        ]);
        break;

      case "fuel":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          i.spentFuel,
          convertMillisecondsToTime(i.engineHours),
          (i.distance / 1000).toFixed(2) + " " + trans("km"),
        ]);
        break;

      case "odometer":
        setExportedDataBody([]);
        formattedData = exportData?.map((i) => [
          i.deviceName,
          (i.endOdometer / 1000).toFixed(1) + " " + trans("km"),
          formatDateString(i.endTime),
          i.spentFuel,
        ]);
        break;
      default:
        formattedData = [];
    }
		setExportedDataBody(formattedData);
		setFileName(`${getShortPath()}.xlsx`);
	}, [data, setExportedDataBody, getShortPath()]);

	if (data == undefined)
		return (
			<Empty
				title={trans("Create Filter")}
				subtitle={trans(
					"Click on filter and create report filter to extract data"
				)}
			/>
		);
	return (
		<>
			{data?.map((i, indx) => {
				const { formattedDate, formattedTime } = formatDate(i?.fixTime);
				const { formattedDate: startDate, formattedTime: startTime } =
					formatDate(i.startTime);

				const { formattedDate: endDate, formattedTime: endTime } = formatDate(
					i.endTime
				);

				return (
					<div key={indx} className="table-row">
						{getShortPath() === "vehiclestrips" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow value={startDate + " " + startTime} />
								<TableRow
									style="cursor text-primary"
									value={
										geoCodes[indx]?.start
											? truncateItem(geoCodes[indx]?.start)
											: trans("Get current address")
									}
									title={geoCodes[indx]?.start}
									onClick={() =>
										fetchMultipleGeoCodePosition(
											i.startLat,
											i.startLon,
											indx,
											"start"
										)
									}
								/>
								<TableRow
									value={
										(i.startOdometer / 1000).toFixed(1) + " " + trans("km")
									}
								/>
								<TableRow value={endDate + " " + endTime} />
								<TableRow
									style="cursor text-primary"
									value={
										geoCodes[indx]?.end
											? truncateItem(geoCodes[indx]?.end)
											: trans("Get current address")
									}
									title={geoCodes[indx]?.end}
									onClick={() =>
										fetchMultipleGeoCodePosition(
											i.endLat,
											i.endLon,
											indx,
											"end"
										)
									}
								/>
								<TableRow
									value={(i.endOdometer / 1000).toFixed(1) + " " + trans("km")}
								/>
								<TableRow
									value={
										knotsToKmPerHour(i.averageSpeed).toFixed(2) +
										" " +
										trans("km/h")
									}
								/>
								<TableRow
									value={(i.distance / 1000).toFixed(1) + " " + trans("km")}
								/>
								<TableRow value={convertMillisecondsToTime(i.duration)} />
							</>
						)}
						{getShortPath() === "speed" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow value={startDate + " " + startTime} />
								<TableRow value={endDate + " " + endTime} />
								<TableRow
									value={
										knotsToKmPerHour(i.maxSpeed).toFixed(1) +
										" " +
										trans("km/h")
									}
								/>
								<TableRow
									value={
										knotsToKmPerHour(i.averageSpeed).toFixed(1) +
										" " +
										trans("km/h")
									}
								/>
								<TableRow value={convertMillisecondsToTime(i.engineHours)} />
							</>
						)}
						{getShortPath() === "alarm" && (
							<>
								<TableRow value={i.eventTime} />
								<TableRow value={i.type} />
								<TableRow value={i.Data} />
							</>
						)}
						{getShortPath() === "stop" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow value={startDate + " " + startTime} />
								<TableRow value={endDate + " " + endTime} />
								<TableRow value={convertMillisecondsToTime(i.duration)} />
								<TableRow
									value={(i.endOdometer / 1000).toFixed(1) + " " + trans("km")}
								/>
								<TableRow
									value={
										geoCodes[indx]
											? truncateItem(geoCodes[indx])
											: trans("Get current address")
									}
									title={geoCodes[indx]}
									onClick={() =>
										fetchGeoCodePosition(i.latitude, i.longitude, indx)
									}
									style="cursor text-primary"
								/>
							</>
						)}
						{getShortPath() === "distance" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow value={endDate + " " + endTime} />
								<TableRow
									value={(i.distance / 1000).toFixed(1) + " " + trans("km")}
								/>
								<TableRow
									value={
										(i.startOdometer / 1000).toFixed(1) + " " + trans("km")
									}
								/>
								<TableRow
									value={(i.endOdometer / 1000).toFixed(1) + " " + trans("km")}
								/>
							</>
						)}
						{getShortPath() === "route" && (
							<>
								<TableRow value={Name?.name} style="ps-0 text-primary" />
								<TableRow value={formattedDate + " " + formattedTime} />
								<TableRow
									style="cursor text-primary"
									value={
										geoCodes[indx]
											? truncateItem(geoCodes[indx])
											: trans("Get current address")
									}
									title={geoCodes[indx]}
									onClick={() =>
										fetchGeoCodePosition(i.latitude, i.longitude, indx)
									}
								/>
								<TableRow
									value={(i.speed ?? 0).toFixed(2) + " " + trans("km/h")}
								/>
								<TableRow
									value={
										(i.attributes.totalDistance ?? 0).toFixed(1) +
										" " +
										trans("km")
									}
								/>
								<TableRow
									value={
										(i.attributes.distance ?? 0).toFixed(1) + " " + trans("km")
									}
								/>
								<TableRow value={i.attributes.ignition ? "ON" : "OFF"} />
								<TableRow
									value={i.attributes.odometer / 1000 + " " + trans("km")}
								/>
								<TableRow value={i.attributes.event} />
								<TableRow value={(i.attributes.power ?? 0).toFixed(2)} />
								<TableRow value={(i.attributes.battery ?? 0).toFixed(2)} />
							</>
						)}
						{getShortPath() === "fuel" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow value={i.spentFuel} />
								<TableRow value={convertMillisecondsToTime(i.engineHours)} />
								<TableRow
									value={(i.distance / 1000).toFixed(2) + " " + trans("km")}
								/>
							</>
						)}
						{getShortPath() === "odometer" && (
							<>
								<TableRow value={i.deviceName} style="ps-0 text-primary" />
								<TableRow
									value={(i.endOdometer / 1000).toFixed(1) + " " + trans("km")}
								/>
								<TableRow value={endDate + " " + endTime} />
								<TableRow value={i.spentFuel} />
							</>
						)}
					</div>
				);
			})}
			{data?.length === 0 && (
				<Empty
					title={trans("No Reports Found")}
					subtitle={trans("Create new report now!")}
				/>
			)}
		</>
	);
}
